import { MapPin, Phone, Mail } from "lucide-react";
import { SITE } from "@/lib/site";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#F2EBE1]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <p className="uppercase tracking-[0.2em] text-xs font-semibold text-[#8B5E3C] mb-4">
            Our Story
          </p>
          <h2 className="font-serif-display text-4xl md:text-5xl font-semibold text-[#2C2621] tracking-tight leading-tight">
            Over 25 years of craft, in every cup
          </h2>
          <div className="mt-6 space-y-5 text-[#594D42] text-lg leading-relaxed">
            <p>
              The Kingston Coffee Company brings over 25 years of craft and care to weddings,
              corporate events, and private gatherings of every kind.
            </p>
            <p>
              Our exclusive, hand-selected Monorail beans are transformed into exceptional
              gourmet beverages — tailored to your vision, your guests, and your occasion.
              Paired with a curated selection of house-made treats, our full-service espresso
              bar is the detail your event will be remembered for.
            </p>
            <p>
              Based in {SITE.location}, we proudly serve {SITE.serviceArea} with full-service,
              barista-staffed coffee experiences.
            </p>
            <p className="font-serif-display text-2xl md:text-3xl text-[#8B5E3C] italic pt-2">
              Because great events deserve a great cup.
            </p>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-4 sm:gap-8">
            <a href={SITE.phoneHref} data-testid="about-phone" className="flex items-center gap-3 text-[#2C2621] hover:text-[#8B5E3C] transition-colors">
              <Phone size={18} strokeWidth={1.5} className="text-[#8B5E3C]" />
              <span className="font-medium">{SITE.phone}</span>
            </a>
            <a href={SITE.emailHref} data-testid="about-email" className="flex items-center gap-3 text-[#2C2621] hover:text-[#8B5E3C] transition-colors">
              <Mail size={18} strokeWidth={1.5} className="text-[#8B5E3C]" />
              <span className="font-medium">{SITE.email}</span>
            </a>
          </div>
        </div>

        <div className="relative">
          <div className="relative rounded-lg overflow-hidden shadow-lg">
            <img
              src={SITE.images.espresso}
              alt="Barista pouring latte art"
              className="w-full h-[520px] object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white rounded-lg shadow-md border border-[#E5DFD3] px-6 py-5 flex items-center gap-3">
            <MapPin size={22} strokeWidth={1.5} className="text-[#8B5E3C]" />
            <div className="leading-tight">
              <p className="font-serif-display text-xl font-semibold text-[#2C2621]">Kingston, WA</p>
              <p className="text-sm text-[#594D42]">Serving Greater Puget Sound</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
